import React, { Component } from "react";
import { injectIntl, IReactIntlProps } from "../../../views/common/extensions";
import { Button } from "@mui/material";
import { StampDirection } from "../../../shared/timeclock/models";

interface ButtonOkProps extends IReactIntlProps {
    onClickHandler: (direction: StampDirection) => void;
    primary: boolean;
    direction: StampDirection;
}

class TimeStampButton extends Component<ButtonOkProps> {
    render() {
        const { primary, direction, onClickHandler, intl } = this.props;

        const primaryClassName = primary ? "tc-primary" : "";

        return (
            <Button
                variant="contained"
                className={`tc-button tc-${StampDirection[direction].toLocaleLowerCase()} ${primaryClassName}`}
                onClick={() => onClickHandler(direction)}
            >
                {intl.formatMessage({ id: "Direction." + StampDirection[direction] })}
            </Button>
        );
    }
}

export default injectIntl(TimeStampButton);
